import { Injectable } from '@angular/core';
import { CwtAuthStoreService, LoginResult } from '@cawita/core-front/auth';
import { User } from '@shared/models';

@Injectable({ providedIn: 'root' })
export class KatchaAuthStore extends CwtAuthStoreService<User> {
    protected onLoginSuccess(res: LoginResult<User>) {
        super.onLoginSuccess(res);
        this.setState(c => ({
            ...c,
            assetToken: res?.staticAccessToken?.value
        }));
    }

    public forceLogin(res: LoginResult<User>) {
        this.onLoginSuccess(res);
        this.persist();
        this.router.navigate(this.config.navigation.defaultRoute);
    }
}
